module.exports = {
  app: {
    ENV: "live",
    currentVersion: 30,

    APP_LAYER: "https://back.markedprivate.com/api",
    IMAGE_LAYER: "https://image.markedprivate.com/api",
    VIDEO_LAYER: "https://video.markedprivate.com/api",
    POINTS_LAYER: "https://points.markedprivate.com/api",
    POLLS_LAYER: "https://polls.markedprivate.com/api",
    VENDORS_LAYER: "https://vendors.markedprivate.com/api",
  },

  google: {
    API_KEY: "AIzaSyD-WE2ws5v4tjiho7t62ANfCs-m-53-IO4",
    CLIENT_ID: "",
    SECRET: "",
  },
  pusher: {
    key: "ad1d6d832d3872a5c5bb",
  },
  stripe: {
    client_id: "ca_I1zo0uvOyuN1jeyYsyccYCt9zqnPRHN3",
  },

  qb: {
    CREDENTIALS: {
      appId: 47174,
      authKey: "SV84gSVUUMOra8r",
      authSecret: "3JpBqSwKk6dX8rE",
      accountKey: "eKzsgHKf4LBpVx_yRQS7"
    },
    CONFIG: {
      chatProtocol: {
        // bosh: "https://chatqb.markedprivate.com:5281",
        // websocket: "wss://chatqb.markedprivate.com:5281",
        active: 2,
      },
      streamManagement: {
        enable: true,
      },
      endpoints: {
        api: "apiqb.markedprivate.com",
        chat: "chatqb.markedprivate.com",
      },
      webrtc: {
        iceServers: [
          { url: "stun:stun.l.google.com:19302" },
          {
            url: "stun:turn.quickblox.com",
            username: "quickblox",
            credential: "baccb97ba2d92d71e26eb9886da5f1e0",
          },
          {
            url: "turn:turn.quickblox.com:3478?transport=udp",
            username: "quickblox",
            credential: "baccb97ba2d92d71e26eb9886da5f1e0",
          },
          {
            url: "turn:turn.quickblox.com:3478?transport=tcp",
            username: "quickblox",
            credential: "baccb97ba2d92d71e26eb9886da5f1e0",
          },
        ],
      },
      debug: {
        debug: false,
      },
    },
  },

  vendors: {
    CAGER_CLIENT_ID: 32,
    WESTERN_EDGE_CLIENT_ID: 113,
    MP_ID: 1,
    ENCAPPTURE_CLIENT_ID: 146,
    TPI_CLIENT_ID: 89,
    IMAC_CLIENT_ID: 122,
    TROTTA_CLIENT_ID: 118,
    G2_CLIENT_ID: 76,
    HOLON_HEALTH_CLIENT_ID: 129,
    IFO_CLIENT_ID: 131,
    HARVARD_CLIENT_ID: 135,
  },
}
